var _regeneratorRuntime = require("/home/circleci/project/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/circleci/project/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var STRIPE_URL = 'https://api.stripe.com/v1/';

var FORMURLENCODED = require('form-urlencoded');

module.exports = function (key) {
  return {
    createToken: function () {
      var _createToken = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(details) {
        var keys, index, token, type, newDetails;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                keys = Object.keys(details);
                index = _findType(details, keys);

                if (!(index == 0)) {
                  _context.next = 10;
                  break;
                }

                type = keys[index];
                newDetails = _convertDetails(type, details[type]);
                _context.next = 7;
                return _createTokenHelper(newDetails, key);

              case 7:
                token = _context.sent;
                _context.next = 13;
                break;

              case 10:
                _context.next = 12;
                return _createTokenHelper(details, key);

              case 12:
                token = _context.sent;

              case 13:
                return _context.abrupt("return", _parseJSON(token));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function createToken(_x) {
        return _createToken.apply(this, arguments);
      }

      return createToken;
    }()
  };
}; // Stripe normally only allows for fetch format for the details provided.
// _findType allows the user to use the node format of the details by
// figuring out which format/type the details provided are.


function _findType(details, keys) {
  if (details.card != null) {
    return keys.indexOf("card");
  } else if (details.bank_account != null) {
    return keys.indexOf("bank_account");
  } else if (details.pii != null) {
    return keys.indexOf("pii");
  } else return false;
} // _convertDetails converts and returns the data in the given details
// to the correct Stripe format for the given type.


function _convertDetails(type, details) {
  var convertedDetails = {};

  for (var data in details) {
    var string = type + '[' + data + ']';
    convertedDetails[string] = details[data];
  }

  return convertedDetails;
} // Stripe gives a JSON object with the token object embedded as a JSON string.
// _parseJSON finds that string in and returns it as a JSON object, or an error
// if Stripe threw an error instead. If the JSON does not need to be parsed, returns the token.


function _parseJSON(_x2) {
  return _parseJSON2.apply(this, arguments);
}

function _parseJSON2() {
  _parseJSON2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(token) {
    var body;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(token._bodyInit == null)) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", token);

          case 4:
            _context2.next = 6;
            return token.json();

          case 6:
            body = _context2.sent;
            return _context2.abrupt("return", body);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _parseJSON2.apply(this, arguments);
}

function _createTokenHelper(details, key) {
  var formBody = FORMURLENCODED(details);
  return fetch(STRIPE_URL + 'tokens', {
    method: 'post',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer ' + key
    },
    body: formBody
  });
}